(() => {
  if (window.rplProductReviewLinkInstalled) return;
  window.rplProductReviewLinkInstalled = true;
  const update = () => {
    const target = document.querySelector('#judgeme_product_reviews');
    const widget = target?.querySelector('.jdgm-rev-widg');
    const count = Number(widget?.dataset.numberOfReviews || 0);
    const rating = Number(widget?.dataset.averageRating || 0);
    document.querySelectorAll('.rpl-product-review-link').forEach(link => {
      const visible = count > 0 && rating > 0 && rating <= 5;
      if (link.hidden === visible) link.hidden = !visible;
      if (!visible) return;
      const label = `${rating.toFixed(1)} · ${count} ${count === 1 ? 'review' : 'reviews'}`;
      const text = link.querySelector('.rpl-review-label');
      if (text.textContent !== label) text.textContent = label;
      link.style.setProperty('--rating-fill', `${rating / 5 * 100}%`);
      link.setAttribute('aria-label', `${rating.toFixed(1)} out of 5 stars, ${count} customer ${count === 1 ? 'review' : 'reviews'}. Read reviews.`);
    });
  };
  const start = () => {
    update();
    new MutationObserver(update).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews','data-average-rating']});
    document.addEventListener('click', event => {
      const link = event.target.closest('.rpl-product-review-link');
      if (!link) return;
      const target = document.querySelector('#judgeme_product_reviews');
      if (!target) return;
      event.preventDefault();
      const header = document.querySelector('store-header, #shopify-section-header, .shopify-section--header');
      target.style.scrollMarginTop = `${(header?.getBoundingClientRect().height || 140) + 24}px`;
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
